import React, { Component } from "react";
import PropTypes from "prop-types";
import mojs from "mo-js";
import "./NewKudos.css";

// Sets duration of all animations
const tlDuration = 300;
//setInterval to count kudos when mouse is being held down
let kudosCounterInterval;
let kudosCounterSpeed = 300;
//setTimeout to delay the closeCounter from firing once mouse is not down
let closeCounterTimeout;
let closeCounterAfter = 1500;

let triangleBurstProps = {
  parent: "#kudos-button-container",
  className: "triangle-burst",
  top: "25%", //just pushes it down a little so it looks like it's coming from behind the circle
  left: "1.8em", //hardcoded half the width of the kudos circle
  radius: { 25: 400 },
  count: 6,
  degree: 70,
  angle: -30,
  duration: tlDuration,
  isShowEnd: false,
  children: {
    shape: "polygon",
    radius: { 20: 0 },
    scale: 1,
    fill: "#ff5c64",
    angle: 210,
    delay: 25,
    speed: 0.3,
    easing: mojs.easing.bezier(0.1, 1, 0.3, 1),
  },
};

let circleBurstProps = {
  parent: "#kudos-button-container",
  className: "circle-burst",
  top: "25%", //just pushes it down a little so it looks like it's coming from behind the circle
  left: "1.8em", //hardcoded half the width of the kudos circle
  radius: { 25: 350 },
  count: 4,
  degree: 50,
  angle: -20,
  duration: tlDuration,
  isShowEnd: false,
  children: {
    shape: "circle",
    radius: { 10: 0 },
    scale: 1,
    fill: "#448aff",
    delay: 10,
    speed: 0.2,
    easing: mojs.easing.bezier(0.1, 1, 0.3, 1),
  },
};

let rectBurstProps = {
  parent: "#kudos-button-container",
  className: "rect-burst",
  top: "25%", //just pushes it down a little so it looks like it's coming from behind the circle
  left: "1.8em", //hardcoded half the width of the kudos circle
  radius: { 25: 300 },
  count: 4,
  degree: 40,
  angle: -20,
  duration: tlDuration,
  isShowEnd: false,
  children: {
    shape: "rect",
    radius: { 8: 0 },
    scale: 1,
    fill: "#fbc800",
    delay: 0,
    speed: 0.18,
    easing: mojs.easing.bezier(0.1, 1, 0.3, 1),
  },
};

class NewKudos extends Component {
  constructor() {
    super();

    this.state = {
      //If ever greater than 0, then do not count kudos onMouseUp
      holdCounter: 0,
      mouseDown: false,
      counterAnimating: false,
      //When the closeCounter is rendered, do not try and render another one
      closeCounterRendered: false,
      //When the closeCounter is skipped, make sure to close it onMouseUp
      closeCounterSkipped: false,
    };
  }

  randomizedBurst = (shape, min, max) => {
    shape.angle = Math.floor(Math.random() * (max - min + 1)) + min;

    const burst = new mojs.Burst(shape);
    return burst;
  };

  fireBurst = () => {
    const triangleBurst = this.randomizedBurst(triangleBurstProps, -40, 10);
    const circleBurst = this.randomizedBurst(circleBurstProps, -30, 0);
    const rectBurst = this.randomizedBurst(rectBurstProps, -25, -5);

    var animationTimeline = new mojs.Timeline();
    animationTimeline.add([triangleBurst, circleBurst, rectBurst]);
    animationTimeline.play();
  };

  countKudos = () => {
    this.setState({
      holdCounter: this.state.holdCounter + 1,
    });
    this.props.commitUpdatedKudosConcernsCount("kudosGiven");
    window.analytics.track("New Kudos Given");
    this.fireBurst();
  };

  openCounter = () => {
    let onStart = () => {
      this.setState({
        counterAnimating: true,
      });
    };
    let counterAnimationOpen = {
      el: "#kudos-counter",
      isShowStart: false,
      isShowEnd: true,
      x: "-50%",
      y: { 0: "-6em" },
      opacity: { 0: 1 },
      duration: tlDuration / 2,
      onStart() {
        onStart();
      },
    };

    let counterAnimatorOpen = new mojs.Html(counterAnimationOpen);
    let animationTimeline = new mojs.Timeline();
    animationTimeline.add(counterAnimatorOpen);
    animationTimeline.play();
  };

  closeCounter = () => {
    let onStart = () => {
      this.setState({
        closeCounterRendered: true,
      });
    };
    let onComplete = () => {
      this.setState({
        counterAnimating: false,
        closeCounterRendered: false,
        holdCounter: 0,
      });
    };

    let counterAnimationClose = {
      el: "#kudos-counter",
      isShowStart: true,
      isShowEnd: true,
      x: "-50%",
      y: { "-6em": "-12em" },
      opacity: { 1: 0 },
      duration: tlDuration / 2,
      onStart() {
        onStart();
      },
      onComplete() {
        onComplete();
      },
    };

    let counterAnimatorClose = new mojs.Html(counterAnimationClose);
    let animationTimeline = new mojs.Timeline();
    animationTimeline.add(counterAnimatorClose);
    animationTimeline.play();
  };

  //Will close the counter unless certain conditions are met
  closeCounterWhenReady = () => {
    //When called, make sure that the closeCounterTimeout is reset
    clearTimeout(closeCounterTimeout);

    //If closeCounter isn't rendered yet, and mouse is NOT held down, then render closeCounter after a delay
    if (!this.state.closeCounterRendered) {
      closeCounterTimeout = setTimeout(() => {
        if (!this.state.mouseDown && !this.state.closeCounterRendered) {
          this.closeCounter();
        } else {
          //We skipped calling closeCounter(), so allow it to be called onMouseUp
          this.setState({
            closeCounterSkipped: true,
          });
        }
      }, closeCounterAfter);
    }
  };

  handleMouseDown = event => {
    //Detect right click or CTRL key (which right clicks) is held down and disregard
    if (event.nativeEvent.which === 3 || event.ctrlKey) {
      return false;
    }

    this.setState(
      {
        mouseDown: true,
        //Resets back to false when a new counter animation is about to beging
        closeCounterSkipped: false,
      },
      () => {
        //Prevents countKudos from firing when button gets clicked while closeCounter is still animating
        if (this.state.closeCounterRendered) {
          return false;
        }

        this.countKudos();

        //Make sure counter is only opened if one isn't open already
        if (!this.state.counterAnimating) {
          this.openCounter();
        }

        this.closeCounterWhenReady();

        //Repeatedly count kudos as long as mouse is being held down
        kudosCounterInterval = setInterval(() => {
          if (this.state.mouseDown) {
            this.countKudos();
          }
        }, kudosCounterSpeed);
      }
    );
  };

  handleMouseUp = () => {
    //Stops counting kudos as soon as mouse is lifted up
    clearInterval(kudosCounterInterval);

    //If mouse started in down position outside of button, disregard it
    if (!this.state.mouseDown) {
      return false;
    }

    this.setState(
      {
        mouseDown: false,
      },
      () => {
        // If mouseDown skipped closeCounter(), then close it now
        if (this.state.closeCounterSkipped) {
          this.closeCounterWhenReady();
        }
      }
    );
  };

  handleMouseLeave = () => {
    if (this.state.mouseDown) {
      this.handleMouseUp();
    }
  };

  render() {
    return (
      <div className="new-kudos-container">
        <div className="kudos-button-container" id="kudos-button-container">
          <div
            className="kudos-button action-button"
            onMouseDown={event => this.handleMouseDown(event)}
            onMouseUp={this.handleMouseUp}
            onMouseLeave={this.handleMouseLeave}
          >
            <div
              className={`kudos-counter ${this.state.holdCounter > 1 &&
              this.state.mouseDown
                ? `pulsate`
                : ``}`}
              id="kudos-counter"
            >
              {this.state.holdCounter}
            </div>
            <div className="kudos-circle action-circle" id="circle">
              <span className="fas fa-thumbs-up icon" />
            </div>
            <div
              className="text-container action-text-container"
              id="text-container"
            >
              <span className="default-text">
                {this.props.kudosGiven > 0
                  ? this.props.kudosGiven
                  : "Give"}{" "}
                Kudos
              </span>
              <span className="hover-text">Give Kudos</span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

NewKudos.propTypes = {
  kudosGiven: PropTypes.number.isRequired,
  commitUpdatedKudosConcernsCount: PropTypes.func.isRequired,
};

export default NewKudos;



// WEBPACK FOOTER //
// ./src/components/NewKudos.js